export default __webpack_public_path__ + "static/media/transmission-tower.15f47f79.svg";